import _ from '@lodash';
import { Button, IconButton, Tooltip, TableCell } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { HiPlay } from 'react-icons/hi';

function ShowOptimizationPipelineButton(props) {
    const history = useHistory();

    const { id } = props;
    const { t } = useTranslation(['common']);

    const handleClick = () => { history.push(`/optimization-pipeline/show/${id || props.item.id}`); };

    return (
        <>

            {props.form && <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={id === 'new'} startIcon={<HiPlay className='hidden sm:flex' />} onClick={handleClick}>{t('show')}</Button>}

            {!props.form && <TableCell className='w-auto text-center' padding='none'>
                <Tooltip title={t('show')}>
                    <IconButton onClick={handleClick}><HiPlay fontSize='large' /></IconButton>
                </Tooltip>
            </TableCell>}

        </>
    );
}

export default ShowOptimizationPipelineButton;